import { config } from '../ProsemirrorConfig';
import { CONTENT_ASSISTANT_INLINE_MENU, CONTENT_ASSISTANT_SLASH_COMMAND, INLINE_IMAGE, LINK, PASTE_OVERRIDE, TRACKING } from '../editorCapabilities/constants';
import { DropPlugin } from '../plugins/DropPlugin';
import { FocusPlugin } from '../plugins/FocusPlugin';
import { createFontPlugin } from '../plugins/FontPlugin';
import { ImageFocusPlugin } from '../plugins/ImageFocusPlugin';
import { createImagePastePlugin } from '../plugins/ImagePastePlugin';
import { PasteOverridePlugin } from '../plugins/PasteOverridePlugin';
import { ScrollViewPlugin } from '../plugins/ScrollViewPlugin';
import { LinkPlugin } from '../plugins/link/LinkPlugin';
import { EmojiPlugin } from '../plugins/suggestion/EmojiPlugin';
import { getDefaultFontProps } from './fontUtils';
import { getContentAssistantHighlightPlugin } from '../plugins/ai-highlight/CAHighlightPlugin';
import { SELECTION_COMMANDS, SLASH_COMMANDS } from '../plugins/ai-highlight/commands';
import { createContentAssistantSlashPlugin } from '../plugins/ai-slash/CASlashPlugin';
import { getSelectedCommandParamsForSlash, onInsertSlashContent } from '../plugins/ai-slash/utils';
import { getGlobalVars } from './globalVarUtil';
import { AutoDetectLinkPlugin } from '../plugins/link/AutoDetectLinkPlugin';
import { AutoLinkOnPastePlugin } from '../plugins/link/AutoLinkOnPastePlugin';
export const getTracking = editorConfig => {
  return editorConfig[TRACKING] || {};
};
export const getKeyMapOptions = editorConfig => {
  const globalVars = getGlobalVars(editorConfig);
  return Object.assign({}, editorConfig.KEYMAP, {
    usePlaintextMode: !!globalVars.usePlaintextMode,
    plaintextOptions: globalVars.plaintextOptions
  });
};
export const capabilitiesThatArePlugins = [CONTENT_ASSISTANT_INLINE_MENU, CONTENT_ASSISTANT_SLASH_COMMAND];
export function buildDefaultRTEConfig(customPlugins, editorConfig, schema, portalApi) {
  var _editorConfig$LINK, _editorConfig$LINK2;
  const inlineImageConfig = editorConfig && editorConfig[INLINE_IMAGE];
  const hasPasteOverrides = editorConfig && editorConfig[PASTE_OVERRIDE];
  const autoDetectLinks = editorConfig && ((_editorConfig$LINK = editorConfig[LINK]) === null || _editorConfig$LINK === void 0 ? void 0 : _editorConfig$LINK.autoDetectLinks);
  const autoLinkOnPaste = editorConfig && ((_editorConfig$LINK2 = editorConfig[LINK]) === null || _editorConfig$LINK2 === void 0 ? void 0 : _editorConfig$LINK2.autoLinkOnPaste);
  const plugins = [LinkPlugin, ScrollViewPlugin, DropPlugin, FocusPlugin, ImageFocusPlugin];
  if (inlineImageConfig) {
    const {
      fileManagerAccess
    } = inlineImageConfig;
    plugins.unshift(createImagePastePlugin({
      fileManagerAccess
    }));
  }
  if (hasPasteOverrides) {
    plugins.push(PasteOverridePlugin);
  }
  if (editorConfig && editorConfig.EMOJI) {
    plugins.push(EmojiPlugin);
  }
  if (editorConfig) {
    plugins.push(createFontPlugin(getDefaultFontProps(editorConfig)));
  }
  if (autoDetectLinks) {
    plugins.push(AutoDetectLinkPlugin);
  }
  if (autoLinkOnPaste) {
    plugins.push(AutoLinkOnPastePlugin);
  }
  if (customPlugins) {
    plugins.push(...customPlugins);
  }
  if (portalApi && editorConfig && editorConfig.CONTENT_ASSISTANT_INLINE_MENU) {
    plugins.push(getContentAssistantHighlightPlugin(Object.assign({
      portalApi,
      usageDescription: 'prosemirror-content-assistant-completion',
      selectionCommands: SELECTION_COMMANDS,
      trackInteraction: () => {}
    }, editorConfig.CONTENT_ASSISTANT_INLINE_MENU)));
  }
  if (portalApi && editorConfig && editorConfig.CONTENT_ASSISTANT_SLASH_COMMAND) {
    plugins.push(createContentAssistantSlashPlugin(Object.assign({
      portalApi,
      commands: SLASH_COMMANDS,
      trackInteraction: () => {},
      usageDescription: 'prosemirror-content-assistant-slash',
      onInsert: onInsertSlashContent,
      getSelectedCommandParams: getSelectedCommandParamsForSlash
    }, editorConfig.CONTENT_ASSISTANT_SLASH_COMMAND)));
  }
  return config(plugins, editorConfig && getKeyMapOptions(editorConfig), schema);
}